import styled from 'styled-components'

const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.error};
  margin-bottom: 1rem;
`

export { ErrorText }
